// extracted by mini-css-extract-plugin
export default {"file":"file_t4KgY"};